import LoginActionHandlerBase from './action_handler_base';
import {SYSTEM_EVENTS} from '../../../events/events';
import {GNWP_SOURCES} from '../../../components/external_links/external_links_consts';
import Event from '../../../utils/event';
import * as INTEGRATION from '../../integration/integration_const';

export default class RegistrationActionHandler extends LoginActionHandlerBase {
    static CLASS = 'RegistrationActionHandler';

    actionName() {
        return 'onregister';
    }

    execute() {
        this.serviceFactory.webLoginService().closeLoginForm();

        let marketingFunction = this.serviceFactory.webLoginService().getMarketingDataFunction();
        this.serviceFactory.integrationService().executeMarketingDataFunction(marketingFunction);
        Event.fire(SYSTEM_EVENTS.WEB_LOGIN_OPEN_REGISTER);
        Event.fire(SYSTEM_EVENTS.INCOMING_MARKETING_FLOW, INTEGRATION.MARKETING_FLOWS.REGISTER_IN_LOGIN);

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_LoginPopup',
            action: 'Register'
        });

        this.serviceFactory.openLinkService().openLink({
            source: GNWP_SOURCES.MEMBERSHIP
        });
    }
}